export default "__VITE_ASSET__DmCv37SL__"